export class UnauthorizedError extends Error {
  constructor(message: any = '') {
    super(message);
    this.name = 'UnauthorizedError';
  }
}
